import { Zap, Building, ShoppingBag, Heart, Landmark, Briefcase } from "lucide-react";
import "../styles/WhoWeServe.scss";

const WhoWeServe = () => {
  const sectors = [
    {
      icon: <Zap className="who-we-serve2__icon" aria-hidden="true" />,
      title: "Utilities"
    },
    {
      icon: <Building className="who-we-serve2__icon" aria-hidden="true" />,
      title: "Insurance & Financial Services"
    },
    {
      icon: <ShoppingBag className="who-we-serve2__icon" aria-hidden="true" />,
      title: "E-commerce"
    },
    {
      icon: <Heart className="who-we-serve2__icon" aria-hidden="true" />,
      title: "Healthcare"
    },
    {
      icon: <Landmark className="who-we-serve2__icon" aria-hidden="true" />,
      title: "Public Sector"
    },
    {
      icon: <Briefcase className="who-we-serve2__icon" aria-hidden="true" />,
      title: "Professional Services"
    }
  ];

  return (
    <section className="who-we-serve2" aria-labelledby="who-we-serve-heading">
      <div id="who-we-serve" className="who-we-serve2__anchor"></div>
      
      <div className="who-we-serve2__container">
        <header className="who-we-serve2__header">
          <h2 id="who-we-serve-heading" className="who-we-serve2__title">
            Who We Serve
          </h2>
          <p className="who-we-serve2__subtitle">
            Our accessibility solutions benefit organizations across various sectors, 
            helping them reach more users and comply with legal requirements.
          </p>
        </header>

        <div className="who-we-serve2__sectors-wrapper">
          <ul className="who-we-serve2__sectors-container" aria-labelledby="who-we-serve-heading">
            {sectors.map((sector, index) => (
              <li key={index} className="who-we-serve2__sector">
                <div className="who-we-serve2__icon-wrapper" aria-hidden="true">
                  {sector.icon}
                </div>
                <span className="who-we-serve2__sector-title">{sector.title}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default WhoWeServe; 